<template>
  <div class="dis dinline-block vtop mb35 mr20 ml10 cpointer prelative" v-on:click="goDetail(item.id)">
    <div class="igs pabsolute ofhidden">
      <img class="trans" src="../../../assets/images/list_034.jpg" alt="">
    </div>
    <div class="prelative nm fs20 fbold twhite pl25">{{item.name}}</div>
    <div class="fs18 fbold pl25 mt15 mb15">{{item.school}}</div>
    <div class="fs12 tc9 pl25">
      <span class="mr25">年限：{{item.years}}年</span>
      <span>层次：{{item.theme_name}}</span>
    </div>
  </div>
</template>

<script>
    export default {
      name: "item",
      props: [
        'item',
      ],
      methods:{
        goDetail (id){
          let path = `/hedu/professional/detail?id=${id}` 
          let routeData = this.$router.resolve({
              path
          })
          window.open(routeData.href, '_blank')
          //this.$router.push({path:'/hedu/professional/detail',query:{id:id}})
        }
      }
    }
</script>

<style scoped>
.dis{width: 372px;height: 150px;box-shadow: 0 0 5px #ccc;}
.dis .igs{z-index: 1;left: 0;right: 0;height: 58px;}
.dis .nm{z-index: 2;height: 58px;line-height: 58px;}
</style>



// WEBPACK FOOTER //
// src/components/hedu/professional/item.vue